import axios from 'axios';
import $config from './config';

const instance = axios.create({
    baseURL: $config.baseURL, // 'https://streampay.kkmport.kz:4000/', 'https://streampay.kkmport.kz:4001/LK'
    withCredentials: true,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

// Добавляем interceptor для запросов, чтобы было видно в DevTools, какой запрос выполняется
// ВНИМАНИЕ! Логику не привязывать к этому GET параметру, он исключительно для быстрого поиска запроса глазами!
instance.interceptors.request.use(config => {
    if (config.method === 'post' && config.data?.method && !config?.url?.includes('m=')) {
        const separator = config.url?.includes('?') ? '&' : '?';
        config.url += `${separator}m=${encodeURIComponent(config.data.method)}`;
    }

    return config;
});

export default instance;
